var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicingReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_257_60765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_257_60765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0769C9.58444 18.0769 9.22951 17.9297 8.93521 17.6354C8.64076 17.3411 8.49354 16.9861 8.49354 16.5704H11.5065C11.5065 16.9861 11.3592 17.3411 11.0648 17.6354C10.7705 17.9297 10.4156 18.0769 10 18.0769ZM3.75 15.7371V14.4873H5.25646V8.26917C5.25646 7.17736 5.58313 6.20674 6.23646 5.35729C6.88979 4.50799 7.73889 3.94875 8.78375 3.67959C8.68222 3.91028 8.60257 4.15091 8.54479 4.40146C8.48715 4.65202 8.44444 4.90813 8.41667 5.16979C7.85583 5.45618 7.39722 5.87209 7.04083 6.4175C6.68458 6.96292 6.50646 7.58014 6.50646 8.26917V14.4873H13.4935V11.3125C13.7019 11.3381 13.9102 11.3495 14.1185 11.3469C14.3269 11.3442 14.5352 11.3274 14.7435 11.2965V14.4873H16.25V15.7371H3.75ZM13.3013 9.48709L13.1315 8.49354C12.9167 8.42952 12.7151 8.34861 12.5265 8.25084C12.3378 8.15306 12.1592 8.02459 11.9904 7.86542L11.0385 8.19229L10.3975 7.14417L11.1635 6.48729C11.1037 6.25327 11.0737 6.01924 11.0737 5.78521C11.0737 5.55132 11.1037 5.31736 11.1635 5.08334L10.3975 4.42625L11.0385 3.37834L11.9904 3.70521C12.1539 3.54604 12.3313 3.41757 12.5225 3.31979C12.7138 3.22202 12.9167 3.14104 13.1315 3.07688L13.3013 2.08334H14.5513L14.721 3.07688C14.9359 3.14104 15.1389 3.22202 15.33 3.31979C15.5213 3.41757 15.6986 3.54604 15.8621 3.70521L16.814 3.37834L17.455 4.42625L16.689 5.08334C16.7488 5.31736 16.7788 5.55132 16.7788 5.78521C16.7788 6.01924 16.7488 6.25327 16.689 6.48729L17.455 7.14417L16.814 8.19229L15.8621 7.86542C15.6933 8.02459 15.5147 8.15306 15.326 8.25084C15.1376 8.34861 14.9359 8.42952 14.721 8.49354L14.5513 9.48709H13.3013ZM13.9263 7.51604C14.406 7.51604 14.8144 7.3475 15.1515 7.01042C15.4885 6.67334 15.6571 6.26493 15.6571 5.78521C15.6571 5.30549 15.4885 4.89709 15.1515 4.56C14.8144 4.22292 14.406 4.05438 13.9263 4.05438C13.4465 4.05438 13.0381 4.22292 12.701 4.56C12.364 4.89709 12.1954 5.30549 12.1954 5.78521C12.1954 6.26493 12.364 6.67334 12.701 7.01042C13.0381 7.3475 13.4465 7.51604 13.9263 7.51604Z",
    fill: "#3F3F46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicingReminder);
export default __webpack_public_path__ + "static/media/Servicing & Reminder.28db3ad67c53ebf9d13a9ec8dd6a6ce8.svg";
export { ForwardRef as ReactComponent };